// Обращения: пожаловаться и оспорить блокировку. SMY-80 · экран 11
//
// Срок ответа приезжает с сервера полем `dueAt`, а не считается здесь.
// Обещание, данное человеку, живёт в одном месте — иначе оно разойдётся с
// сервером при первой правке порогов, и разойдётся молча.

import type { ComplaintKind, ComplaintStatus } from '@smyslika/core'

import type { Client } from './client.ts'

export interface Complaint {
  id: string
  kind: ComplaintKind
  /** На какой результат жалуются. Пусто у оспаривания блокировки. */
  runId?: string
  body: string
  status: ComplaintStatus
  /** Что ответили. Есть только у закрытого обращения. */
  resolution?: string
  /** К какому сроку обещали ответить. */
  dueAt: string
  resolvedAt?: string
  createdAt: string
}

/** Ответ на отправку: обращение плюс обещание словами, для показа сразу. */
export interface Filed extends Complaint {
  promise: string
}

export const createComplaints = (client: Client) => ({
  /** Мои обращения, свежие сверху. */
  list: async () => (await client.request<{ complaints: Complaint[] }>('/v1/complaints')).complaints,

  file: (args: { kind?: ComplaintKind; runId?: string; text: string }) =>
    client.request<Filed>('/v1/complaints', { method: 'POST', body: args }),
})

export type ComplaintsApi = ReturnType<typeof createComplaints>
